// Supported language codes for the application
export const supportedLangs = [
  'en',
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'pl',
  'pt',
  'ru',
  'tr',
  'zh-CN',
  'zh-TW',
]

/**
 * Extracts the current language from the URL path
 * @param pathname - The current pathname (defaults to window.location.pathname)
 * @returns The language code if found and supported, otherwise 'en'
 */
export const getCurrentLanguageFromUrl = (pathname: string = window.location.pathname): string => {
  const pathSegments = pathname.split('/').filter((segment) => segment !== '')
  const urlLanguage =
    pathSegments.length > 0 && supportedLangs.includes(pathSegments[0]) ? pathSegments[0] : 'en'
  return urlLanguage
}
